import { render, staticRenderFns } from "./LotGeneralInfoPanel.vue?vue&type=template&id=0b0921db&scoped=true"
import script from "./LotGeneralInfoPanel.vue?vue&type=script&lang=ts"
export * from "./LotGeneralInfoPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0921db",
  null
  
)

export default component.exports